import { MapPin, Phone, Clock, Navigation } from "lucide-react";

const LocationSection = () => {
  const searchTerms = [
    "Diastasis Recti doctor near me",
    "Post pregnancy physiotherapy in Lucknow",
    "Women physiotherapist in Lucknow",
    "Mommy tummy treatment Lucknow",
  ];

  return (
    <section id="contact" className="section-spacing bg-stone-50" data-testid="location-section">
      <div className="section-container">
        {/* SEO Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            Visit Us in Lucknow
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-testid="location-headline">
            Best Diastasis Recti Treatment in Lucknow
          </h2>
          <p className="text-lg text-stone-600">
            Sky PhysioRehab provides specialized rehabilitation care tailored for women's health, conveniently located in Gomti Nagar.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Map */}
          <div className="bg-white rounded-3xl overflow-hidden shadow-lg h-full min-h-[450px]" data-testid="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.2543!2d81.0177!3d26.8467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be32af125e453%3A0x21c2ce64189cf3ef!2sSky&#39;s%20PhysioRehab%20%26%20Slimming%20Centre!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '450px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Sky's PhysioRehab Location"
              className="w-full block"
            ></iframe>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            {/* Address Card */}
            <div className="bg-white rounded-2xl p-6 border border-stone-100" data-testid="address-card">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-blue-700" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-blue-900 mb-2">Clinic Address</h3>
                  <p className="text-stone-600">
                    3/173, Vikrant Khand 3, Vikrant Khand,<br />
                    Gomti Nagar, Lucknow,<br />
                    Uttar Pradesh 226010
                  </p>
                  <a
                    href="https://www.google.com/maps/dir//Sky's+PhysioRehab+%26+Slimming+Centre"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-blue-700 hover:text-blue-800 font-medium mt-3"
                    data-testid="get-directions-btn"
                  >
                    <Navigation size={16} />
                    Get Directions
                  </a>
                </div>
              </div>
            </div>

            {/* Phone Card */}
            <div className="bg-white rounded-2xl p-6 border border-stone-100" data-testid="phone-card">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Phone className="text-emerald-600" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-blue-900 mb-2">Contact</h3>
                  <a
                    href="tel:+918800095625"
                    className="text-xl font-semibold text-blue-700 hover:text-blue-800"
                    data-testid="phone-number"
                  >
                    +91 88000 95625
                  </a>
                  <p className="text-stone-500 text-sm mt-1">WhatsApp available on this number</p>
                </div>
              </div>
            </div>

            {/* Hours Card */}
            <div className="bg-white rounded-2xl p-6 border border-stone-100" data-testid="hours-card">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-pink-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Clock className="text-pink-600" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-blue-900 mb-2">Clinic Hours</h3>
                  <p className="text-stone-600">
                    Monday - Saturday: 9:30 AM - 7:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>

            {/* Search Terms SEO */}
            <div className="bg-gradient-to-r from-pink-50 to-blue-50 rounded-2xl p-6" data-testid="search-terms">
              <p className="text-sm text-stone-500 mb-3">If you're searching for:</p>
              <div className="flex flex-wrap gap-2">
                {searchTerms.map((term, index) => (
                  <span
                    key={index}
                    className="bg-white text-stone-600 px-3 py-1 rounded-full text-sm border border-blue-100"
                  >
                    {term}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
